module.exports = __webpack_public_path__ + "static/wallet-c5ed24393fc65d01cece18e7b0a8f953.png";